import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // പേജ് മാറുമ്പോൾ സ്ക്രോൾ ഏറ്റവും മുകളിലേക്ക് മാറ്റുന്നു
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}